import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import classNames from 'classnames';
import type React from 'react';
import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes, useState } from 'react';
import { type Control, Controller } from 'react-hook-form';
import { FormattedMessage, type IntlShape } from 'react-intl';

import { ValidationViolation } from '../../form/ValidationViolation.tsx';

type CommentInputProps<Element = InputHTMLAttributes<HTMLInputElement>> = Element & {
    name: string;
    // biome-ignore lint/suspicious/noExplicitAny: <react-hook-form> types
    control: Control<any>;
    intl: IntlShape;
    className?: string;
    showInitially?: boolean;
};
export const ControlledCommentInput = forwardRef<
    HTMLTextAreaElement,
    CommentInputProps<TextareaHTMLAttributes<HTMLTextAreaElement>>
>(({ name, control, intl, className, showInitially = false, ...props }, ref) => {
    const [isCommentVisible, setIsCommentVisible] = useState(showInitially);
    const id = `form_id_${name}`;

    const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        setIsCommentVisible(!isCommentVisible);
    };

    return (
        <Controller
            render={({ field, fieldState: { error, invalid } }) => {
                return (
                    <div
                        className={classNames('form-group', className, {
                            'has-error': invalid,
                            'has-feedback': invalid,
                        })}
                    >
                        <FormattedMessage
                            id={
                                isCommentVisible
                                    ? 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.comment-remove'
                                    : 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.comment-link'
                            }
                            values={{
                                link: (chunks: React.ReactNode) => (
                                    <a
                                        onClick={handleLinkClick}
                                        {...getTrackingAttributes({
                                            trigger: 'click',
                                            category: 'link autoTracking',
                                            action: 'link click',
                                            label: isCommentVisible
                                                ? 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.comment-remove'
                                                : 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.comment-link',
                                        })}
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }}
                        />
                        {isCommentVisible && (
                            <div className={'input-group margin-y-10'}>
                                <span className='input-group-addon'>
                                    <span className={'rioglyph  rioglyph-comment'} />
                                </span>

                                <div className='form-control-feedback-wrapper'>
                                    <textarea
                                        {...props}
                                        {...field}
                                        className={classNames('form-control')}
                                        ref={ref}
                                        id={id}
                                    />
                                </div>
                            </div>
                        )}
                        <ValidationViolation violations={error?.message} />
                    </div>
                );
            }}
            name={name}
            control={control}
        />
    );
});
